import { createFileRoute } from '@tanstack/react-router'
import AutomationScreen from './-components/screen'
import { Loading } from '@/layouts/loading'
import {z} from 'zod'
import { pharmacyClient } from '@/connect'

const Params = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(10),
})

export const Route = createFileRoute('/(inventory)/branch/_layout/automations/$id/')({
  component: AutomationScreen,
  validateSearch: Params,
  loaderDeps: ({search: {page, pageSize}}) => ({
    page,
    pageSize,
  }),
  loader: async ({deps}) => {
    return await pharmacyClient.minMaxAutomation({
      page: deps.page,
      pageSize: deps.pageSize,
    })
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1
})